import { CoreModule, LocalizationModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { MetroNavMenuComponent } from './components/metro-nav-menu/metro-nav-menu.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MetroFormInputComponent } from './components/metro-form-input/metro-form-input.component';
import { MetroFormSelectComponent } from './components/metro-form-select/metro-form-select.component';
import { MetroTableComponent } from './components/metro-table/metro-table.component';
import { MetroTableSkeletonComponent } from './components/metro-table-skeleton/metro-table-skeleton.component';
import { MetroFormTextareaComponent } from './components/metro-form-textarea/metro-form-textarea.component';
import { MetroSearchInputComponent } from './components/metro-search-input/metro-search-input.component';
import { MetroButtonComponent } from './components/metro-button/metro-button.component';
import { MetroKpiComponent } from './components/metro-kpi/metro-kpi.component';
import { MetroPaginationComponent } from './components/metro-pagination/metro-pagination.component';
import { MetroModalComponent } from './components/metro-modal/metro-modal.component';
import { MetroIconComponent } from './components/metro-icon/metro-icon.component';
import { MetroConfirmationComponent } from './components/metro-confirmation/metro-confirmation.component';
import { MetroProductCardComponent } from './components/metro-product-card/metro-product-card.component';
import { MobileNavbarComponent } from './components/mobile-navbar/mobile-navbar.component';
import { MetroListCardItemComponent } from './components/metro-list-card-item/metro-list-card-item.component';
import { MetroProductDetailsComponent } from './components/metro-product-details/metro-product-details.component';
import { MetroHeaderComponent } from './components/metro-header/metro-header.component';
import { MetroPublicHeaderComponent } from './components/metro-public-header/metro-public-header.component';
import { MetroUploadImagesComponent } from './components/metro-upload-images/metro-upload-images.component';
import { ClientRegisterFormComponent } from './components/client-register-form/client-register-form.component';
import { ArMobileMaskDirective } from './directives/ar-mobile-mask.directive';
import { MetroCarouselComponent } from './components/metro-carousel/metro-carousel.component';
import { MetroOrderCardItemComponent } from './components/metro-order-card-item/metro-order-card-item.component';
import { MetroCheckoutComponent } from './components/metro-checkout/metro-checkout.component';
import { CouponInputComponent } from './components/coupon-input/coupon-input.component';
import { MetroNotificationComponent } from './components/metro-notification/metro-notification.component';
import { MetroPaymentResultComponent } from './components/metro-payment-result/metro-payment-result.component';
import { MetroProfileComponent } from './components/metro-profile/metro-profile.component';
import { MetroDatePickerComponent } from './components/metro-date-picker/metro-date-picker.component';
import { MetroDateInputPickerComponent } from './components/metro-date-input-picker/metro-date-input-picker.component';
import { MetroSummaryCardComponent } from './components/metro-summary-card/metro-summary-card.component';
import { MetroToastBannerComponent } from './components/metro-toast-banner/metro-toast-banner.component';
import { RegisterOptionsComponent } from './components/register-options/register-options.component';
import { MobileCommunicationBannerComponent } from './components/mobile-communication-banner/mobile-communication-banner.component';

@NgModule({
  declarations: [
    MetroNavMenuComponent,
    MetroFormInputComponent,
    MetroFormSelectComponent,
    MetroTableComponent,
    MetroTableSkeletonComponent,
    MetroFormTextareaComponent,
    MetroSearchInputComponent,
    MetroButtonComponent,
    MetroKpiComponent,
    MetroPaginationComponent,
    MetroModalComponent,
    MetroIconComponent,
    MetroConfirmationComponent,
    MetroProductCardComponent,
    MobileNavbarComponent,
    MetroListCardItemComponent,
    MetroProductDetailsComponent,
    MetroHeaderComponent,
    MetroPublicHeaderComponent,
    MetroUploadImagesComponent,
    ClientRegisterFormComponent,
    ArMobileMaskDirective,
    MetroCarouselComponent,
    MetroOrderCardItemComponent,
    MetroCheckoutComponent,
    CouponInputComponent,
    MetroNotificationComponent,
    MetroPaymentResultComponent,
    MetroProfileComponent,
    MetroDatePickerComponent,
    MetroDateInputPickerComponent,
    MetroSummaryCardComponent,
    RegisterOptionsComponent,
    MobileCommunicationBannerComponent
  ],
  imports: [
    CoreModule,
    LocalizationModule,
    ThemeSharedModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    CommonModule,
    FormsModule,
    RouterModule,
    MetroToastBannerComponent
  ],
  exports: [
    CoreModule,
    LocalizationModule,
    ThemeSharedModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    MetroNavMenuComponent,
    MetroFormInputComponent,
    MetroFormSelectComponent,
    MetroTableComponent,
    MetroTableSkeletonComponent,
    MetroSearchInputComponent,
    MetroButtonComponent,
    MetroKpiComponent,
    MetroPaginationComponent,
    MetroModalComponent,
    MetroIconComponent,
    MetroConfirmationComponent,
    MetroFormTextareaComponent,
    MetroProductCardComponent,
    MobileNavbarComponent,
    MetroListCardItemComponent,
    MetroProductDetailsComponent,
    MetroHeaderComponent,
    MetroPublicHeaderComponent,
    MetroUploadImagesComponent,
    ClientRegisterFormComponent,
    MetroCarouselComponent,
    FormsModule,
    RouterModule,
    ArMobileMaskDirective,
    MetroOrderCardItemComponent,
    MetroCheckoutComponent,
    CouponInputComponent,
    MetroNotificationComponent,
    MetroPaymentResultComponent,
    MetroProfileComponent,
    MetroDatePickerComponent,
    MetroDateInputPickerComponent,
    MetroSummaryCardComponent,
    MetroToastBannerComponent,
    RegisterOptionsComponent,
    MobileCommunicationBannerComponent
  ]
})
export class SharedModule {}

